module.exports = __webpack_public_path__ + "static/rowIcon5.211b486e.svg";